import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { getPlatformNative } from "shared/lib/get-platform-native"
import { Header } from "shared/ui/header/ui"
import { Main } from "widgets/main/ui"
import { Slider } from "widgets/slider/ui"
import { useApp } from "./hooks/use-app"
import { Process } from "widgets/process/ui"
// import { Teachers } from "widgets/teachers/ui"
import { Courses } from "widgets/courses/ui"
import { Feedback } from "widgets/feedback/ui"
import { Footer } from "widgets/footer/ui"
import { Popouts } from "widgets/app/popouts"
import { EducationInfo } from "widgets/education-info"
import { MobileMenuProvider } from "shared/contexts/mobile-menu-context"
import { AccessibilityProvider } from "shared/contexts/accessibility-context"
import { AccessibilityPanel } from "shared/ui/accessibility-panel"
// import { HackathonBanner } from "widgets/hackathon-banner"

const _platform = getPlatformNative()

const HomePage = () => (
    <>
        {/* <HackathonBanner /> */}
        <Main />
        <Slider />
        <Courses />
        <Process />
        <Feedback />
        {/* <Teachers /> */}
        <Footer />
    </>
);

const AppContent = () => {
    const location = useLocation();
    const isHackathonPage = location.pathname === '/hackathon';

    return (
        <>
            <AccessibilityPanel />
            <div className={`app ${_platform}`}>
                <Popouts />
                {!isHackathonPage && <Header />}

                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/education-info" element={<EducationInfo />} />
                </Routes>
            </div>
        </>
    );
};

const App = () => {

    console.log('App')
    console.log('Version 1.2.1')

    useApp()

    return (
        <AccessibilityProvider>
            <MobileMenuProvider>
                <Router>
                    <AppContent />
                </Router>
            </MobileMenuProvider>
        </AccessibilityProvider>
    )
}
export default App
